import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { AuthService } from '../_services/auth.service';
import { UserSessionDataForm } from '../_models/login/user-session-data-form';
import { UserDetailsDataForm } from '../_models/user-details-data-form';
import { UserDataService } from '../_services/user-data.service';
import { ServerInfoDataForm } from '../_models/ServerInfoDataForm';
import { Router } from '@angular/router';
import { SpinnerService } from '../_core/spinner/spinner.service';

@Component({
  selector: 'app-nda',
  templateUrl: './nda.component.html',
  styleUrls: ['./nda.component.css']
})
export class NdaComponent implements OnInit {
  ndaForm: FormGroup;
  recPartyPrintName: string = 'Muthukumar Ramalingam';
  recPartyDesignation: string = 'Director & CEO';
  recPartyEmail: string = 'muthu@dexpatent.com';
  ndaDate: number = Date.now();
  userDetailsDataForm: UserDetailsDataForm = new UserDetailsDataForm();
  serverInfoDataForm: ServerInfoDataForm = new ServerInfoDataForm();

  userDataSession;
  userDisplayName = '';
  userDetailsId = 0;
  userEmail = '';

  // @ViewChild ('contentToConvert') content : ElementRef

  constructor(
    private authService: AuthService,
    private formBuilder: FormBuilder,
    private userDataService: UserDataService,
    private router: Router,
     public spinnerService : SpinnerService
  ) {
  }

  ngOnInit() {

    this.validateNDAForm();

    this.authService.checkUserSession();
    const currentUser = localStorage.getItem('currentUser');
    const currentUserJson: UserSessionDataForm = JSON.parse(currentUser);

    if (currentUserJson != null) {
      this.userDataSession = currentUserJson;
      this.userDetailsId = this.userDataSession.userDetailsId;
      if (this.userDataSession.fullName) {
        this.userDisplayName = this.userDataSession.fullName;
      }
      if (this.userDataSession.userId) {
        this.userEmail = this.userDataSession.userId;
      }
    }
  }
  validateNDAForm() {
    this.ndaForm = this.formBuilder.group({
      ndaAccept: false
    })
  }

  submitNDAForm() {
    this.userDetailsDataForm.userDetailsId = this.userDetailsId;
    this.userDetailsDataForm.nda = 1;
    this.spinnerService.show();
    this.userDataService.acceptNdaForm(this.userDetailsDataForm).subscribe(
      resp =>
      {
        this.spinnerService.hide();
        this.router.navigate(['/main/basicInventionDetails']);
      },error => {
        console.log(error);
        this.spinnerService.hide();
      });
  }

  }
